import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en, es } from './language/language-module';

i18n.use(initReactI18next).init({
  resources: {
    en,
    es,
  },
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
  fallbackLng: 'en',
  supportedLngs: ['en', 'es'],
});

export default i18n;
